<template>
  <div class="loading_visible" v-if="isVisible">
    <v-progress-circular
      :size="100"
      :width="7"
      color="purple"
      indeterminate
    ></v-progress-circular>
    <div>{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: "BaseLoading",
  props: { isVisible: Boolean, message: String }
};
</script>

<style scoped>
.loading_visible {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.91);
  top: 0;
  z-index: 100000;
}

.loading_visible > div {
  display: flex;
  margin: 0 auto;
  color: white;
  margin-top: 10px;
}
</style>
